import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const CheckboxType = new Set([
  'tag',
  'country',
  'keyword',
  'opt_in',
  'segments',
  'select',
  'source',
  'time_zone',
  'shortcode',
  'state',
  'lookup_type',
  'message_status',
  'state_code',
  'is_invalid',
  'select_without_checkbox',
  'select_for_triggers_status',
  'inbox',
  'inbound_message_inbox',
  'select_for_conversation_inbox',
])

export const isMultiSelectWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  filterItem.config.values.length && CheckboxType.has(filterItem.type)
